/*
 * Copyright (c) 2020. Dave van Rijn Development
 */

import React from 'react';
import {Navigate, RouteObject} from 'react-router';
import App from './app';
import LoginController from './components/auth/login/loginController';
import DistanceOverviewController from './components/distance/distanceOverviewController';
import AppRoute from './components/misc/appRoute';
import VehicleSelectController from './components/vehicle/vehicleSelectController';
import {DISTANCE_PATH, LOGIN_PATH, VEHICLES_PATH} from './util/constants';

export const Routes: Array<RouteObject> = [
    {
        path: '*', element: <App/>, children: [
            {path: LOGIN_PATH, element: <AppRoute><LoginController/></AppRoute>},
            {path: DISTANCE_PATH, element: <AppRoute authenticated><DistanceOverviewController/></AppRoute>},
            {path: VEHICLES_PATH, element: <AppRoute authenticated><VehicleSelectController/></AppRoute>},
            {path: '*', element: <Navigate to='/inloggen'/>}
        ]
    }
];